import {Component, Input, OnDestroy, OnInit, ViewChild} from "@angular/core";
import {DossierService} from "../../../../../services";
import {FormControl, FormGroup, ValidatorFn} from "@angular/forms";
import {DictionaryService, ValidatorService} from "@amlCore/services";
import {Unsubscribable} from "rxjs";
import {AlertPanelService, ICustomSelectMapper} from "@amlCore/components";
import {DossierBaseModel} from "../../dossierBaseModel";
import {DossierBaseSubComponent} from "../dossierBaseSub.component";
import {LicenseInfoDossierComponent} from "../licenseInfo";
import {ErrorFLKItemType} from "@amlCore/models";

@Component({
  selector: 'app-sved-ko-dossier',
  styleUrls: ['../../dossier.css'],
  templateUrl: './svedKODossier.component.html'
})
export class SvedKODossierComponent extends DossierBaseSubComponent implements OnInit, OnDestroy {

  @Input() rezidentRf: FormControl;
  rezidentRfValueChanges: Unsubscribable;
  okfsMapper: ICustomSelectMapper;
  okopfMapper: ICustomSelectMapper;
  @ViewChild('licenseInfo') licenseInfo: LicenseInfoDossierComponent;
  rezidentFields = ['opf', 'okfs', 'okpo', 'oktmo', 'okved'];
  notRezidentFields = ['opfn','taxtin'];
  isRezident: boolean = false;
  constructor(protected dossierService: DossierService, protected dictSrv: DictionaryService,
              private validationSrv: ValidatorService, protected dossierBaseModel: DossierBaseModel,
              protected alertPanelService: AlertPanelService) {
    super(dossierService, dictSrv, alertPanelService);
  }

  /**
   * Описание формы
   */
  getFormDescription(): FormGroup {
    return this.dossierBaseModel.getSvedKOType(this.typePage);
  }

  ngOnInit(): void {
    this.loadRemoteData(['okopf', 'okfs']);
    setTimeout(() => {
      this.initRezidentRf(this.rezidentRf.value);
      this.rezidentRfValueChanges = this.rezidentRf.valueChanges.subscribe(value => {
        this.initRezidentRf(value);
      });
      this.addUnsubscribable(this.rezidentRfValueChanges);
    });
    this.okfsMapper = {
      toModel: this.okfsMapperToModel.bind(this)
    } as ICustomSelectMapper;
    this.okopfMapper = {
      toModel: this.okopfMapperToModel.bind(this)
    } as ICustomSelectMapper;
  }

  initRezidentRf(value: boolean): void {
    this.isRezident = value;

    this.rezidentFields.forEach(fieldName => this.setDisabled(fieldName, !value));
    this.notRezidentFields.forEach(fieldName => this.setDisabled(fieldName, value));

    this.updateValidator('inn',
      this.validationSrv.getValidation({
        max: 10,
        min: 5,
        isINN: true,
        isReq: value
      })
    );
    this.updateValidator('kpp',
      this.validationSrv.getValidation({
        max: 9,
        isReq: value
      })
    );
    this.updateValidator('bik',
      this.validationSrv.getValidation({
        min: 9,
        max: 9,
        isReq: value
      })
    );
    this.updateValidator('swift',
      this.validationSrv.getValidation({
        max: 11,
        isReq: !value
      })
    );
    this.formGroupApp.updateValueAndValidity({onlySelf: false});

  }

  updateValidator(fieldName: string, validators: ValidatorFn[]){
    const field = this.f(fieldName);
    field.setValidators(validators);
    field.updateValueAndValidity({onlySelf: true});
  }

  setDisabled(fieldName: string, disable: boolean){
    const field = this.f(fieldName);
    disable ? field.disable({onlySelf: true})
      : field.enable({onlySelf: true});
    field.updateValueAndValidity({onlySelf: false});
  }

  notDisabled(fieldName: string){
    return this.isRezident ? this.rezidentFields.includes(fieldName) : this.notRezidentFields.includes(fieldName);
  }

  okfsMapperToModel(origin: any, isDictData: boolean): any {
    if (isDictData) {
      return {
        code: origin.code,
        name: origin.name
      };
    } else {
      return origin;
    }
  }

  okopfMapperToModel(origin: any, isDictData: boolean): any {
    if (isDictData) {
      return {
        code: origin.code,
        name: origin.name
      };
    } else {
      return origin;
    }
  }

  ngOnDestroy(): void {
    this.unsubscribable();
  }

  openLicenseInfo(event: ErrorFLKItemType): void {
    if (event) {
      this.licenseInfo.openWindow(this.dossierService.errorFLKTable);
    }
  }

}
